// External libraries
import gql from 'graphql-tag';

export const PRE_AUTHORIZE_PAYMENT_MUTATION = gql`
  mutation PreAuthorizePaymentMutation($token: String!) {
    preAuthorizePayment(token: $token) {
      declinedInstruments {
        id
        name
        normalizedProcessorResponse
      }
    }
  }
`;
